import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FileName } from '../../FileName';
import { FileUploadField } from '@/components/UI/FileUploadField';
import { ALLOWED_FILE_SIZES, DOCUMENT_FORMATS } from '@/helpers/common';
import { checkForValidFile } from '@/helpers/utils';
import { Tooltip } from '../../Tooltip';
import s from './index.module.scss';

export const BasicUploadField = ({
  name,
  value = [],
  error,
  onBlur,
  onChange,
  onError,
  onRemove,
  label,
  className,
  uploadLabel,
  uploadDescription,
  acceptFormat = DOCUMENT_FORMATS,
  acceptSize = ALLOWED_FILE_SIZES['1mb'],
  isRequired,
  multiple,
  tooltipContent,
}) => {
  const { t } = useTranslation('components');
  return (
    <div className={classnames(s.wrapper, className)}>
      <div className={classnames(s.label, 'f-16')}>
        {label} {isRequired && '*'}
        {tooltipContent && <Tooltip renderContent={tooltipContent} />}
      </div>
      {value.length ? (
        <div className={s.files}>
          {value.map((file, index) => (
            <FileName key={index} file={file} onRemove={onRemove} />
          ))}
        </div>
      ) : (
        <FileUploadField
          name={name}
          multiple={multiple}
          label={uploadLabel || t('basic_upload_field.upload_the_pdf')}
          description={uploadDescription || t('basic_upload_field.upload_size_desc')}
          accept={acceptFormat}
          error={!!error}
          className={s.upload}
          onBlur={onBlur}
          onChange={e => {
            const files = Object.keys(e.target.files).map(idx => e.target.files[idx]);
            const validFiles = files.filter(file => {
              const { isValid, type, size } = checkForValidFile(file, acceptFormat, acceptSize);
              !isValid && size && onError(t('basic_upload_field.file_size_big'));
              !isValid && type && onError(t('basic_upload_field.incorrect_file_type'));
              return isValid;
            });
            onChange(validFiles);
          }}
        />
      )}
    </div>
  );
};
